/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
 */

require('./app-sonifi');